import styled from 'styled-components'

export const CarouselContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`

/* Constrains the Swiper so it lives between the arrow buttons and clips the
   off-screen slides instead of expanding the row. */
export const SwiperWrapper = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`

/* Vertical padding gives the selected card's primary border room to breathe
   inside the clipped Swiper viewport. */
export const Slide = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 0;
`

export const Card = styled.button<{ selected: boolean }>`
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.secondaryL1};
  border: 2px solid ${({ theme, selected }) => (selected ? theme.colors.primary : 'transparent')};
  transition: border-color 0.15s;

  /* Keep the drag gesture owned by Swiper: no text selection or native
     element/image ghost-dragging competing with the carousel. */
  user-select: none;
  -webkit-user-select: none;
  -webkit-user-drag: none;

  img {
    pointer-events: none;
    -webkit-user-drag: none;
    user-select: none;
  }
`

export const ColorSquare = styled.span<{ color: string }>`
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background-color: ${({ color }) => color};
  border: 1px solid ${({ theme }) => theme.colors.neutralL3};
`
